import React from 'react'

const UniformDetails = () => {
  const slides = [
     
    { title: "./uniform1.jpg", description: 'View Gallery' },
    { title: "./uniform2.jpg ", description: 'View Gallery' },
    { title: " ./uniform3.jpg ", description: 'View Gallery' },
    { title: " ./uniform4.jpg ", description: 'View Gallery' },
    { title: "./uniform5.jpg  ", description: 'View Gallery' },
    { title: " ./uniform6.jpg ", description: 'View Gallery' },
    

];
  return (
    <div>
       <div className="container-fluid">
          <div className="first">
          {slides.map((item, i) => {
              return (
                <div key={i} className="one">
                  <img 
                    src={item?.title}
                    className="mt-3 imght "
                    alt="no_img"
                  />
                </div>
              );
            })}
          </div>
        </div>
    </div>
  )
}

export default UniformDetails